import FieldEditor from "editor/FieldEditor";
import Gallery from "gallery/Gallery";

class FieldEditorGallery extends FieldEditor {
    create() {
        this.handleClick = this.handleClick.bind(this);
        this.$element.addClass("gallery-editing-overlay");

        if (this.$element.attr("data-gallery")) {
            this.setValue(this.$element.attr("data-gallery"));
        } else {
            this.setValue(null);
        }
        this.$element.on("click", this.handleClick)
    }

    handleClick(e, extra) {
        // Used to focus the first gallery item in the product gallery
        if (extra && extra.forced) {
            return;
        }
        this.buildGallery();
        this.gallery.show();
        return false;
    }

    buildGallery() {
        if (!this.gallery) {
            this.gallery = new Gallery(this.value, this.$element.is("[data-profile]") ? this.$element.attr("data-profile") : '1');
            this.gallery.pipe(this);
        }
    }

    destroy() {
        super.destroy();

        this.$element.off("click", this.handleClick);
        this.$element.removeClass("gallery-editing-overlay");
        if (this.gallery) {
            this.gallery.destroy();
            this.gallery = null;
        }
    }

    getValue() {
        if (this.gallery instanceof Gallery) {
            return this.gallery._id;
        }
        return this.value;
    }

    setValue(value) {
        if (value !== null && "object" === typeof value) {
            this.value = value.id;
        } else {
            this.value = value;
        }
        if (this.gallery) {
            this.gallery.destroy();
            this.gallery = null;
        }
    }
}


export default FieldEditorGallery;
